import { createRouter, createWebHistory } from 'vue-router';

const Home = () => import('@/views/index.vue');
const OrderView = () => import('@/views/public/order/id/view.vue');

// Modules
import { Auth } from './modules/auth';
import { Partner } from './modules/partner';

import { Errors } from './modules/errors';
import { authMiddleware } from '@/middleware';
// import { Admin } from './modules/admin';
// import { Company } from './modules/company';
// import { CallCenterBoss } from './modules/call-center-boss';

const routes = [
    {
        path: '/',
        name: 'Home',
        component: Home,
        beforeEnter: [authMiddleware],
    },
    {
        path: '/public/order/:id',
        name: 'PublicOrderView',
        component: OrderView,
        meta: { layout: 'auth' },
    },
    ...Errors,
    ...Auth,
    ...Partner,
    // ...Admin,
    // ...CallCenterBoss,
    // ...Company,
];

const router = new createRouter({
    history: createWebHistory(),
    routes,
    // scrollBehavior(to, from, savedPosition) {
    //     if (savedPosition) {
    //         return savedPosition;
    //     } else {
    //         return { left: 0, top: 0 };
    //     }
    // },
});

export default router;
